import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { rgba } from 'polished';

// Import styles
import { flex, customMinResponsive, size, transitionMain } from 'components/styles';

// Import assets
import { ReactComponent as CloseIcon } from 'assets/icons/ic_close.svg';

export const Wrapper = styled.div`
	${flex()}
	padding: 3rem 0;
	border-bottom: 1px solid ${({ theme }) => rgba(theme.configurator.bg.contrast, 0.2)};

	${customMinResponsive(
		size.semi,
		css`
			padding: 3rem 6rem;
		`
	)}
`;

export const Container = styled.div`
	${flex({ jc: 'space-between', fw: 'wrap', ai: 'flex-start' })}
	max-width: 117.4rem;
	width: 100%;
	gap: 2rem;
	position: relative;

	${customMinResponsive(
		size.semi,
		css`
			align-items: center;
		`
	)}
`;

export const StepTitle = styled.h1`
	color: ${({ theme }) => theme.configurator.color.primary};
	font-size: 1.8rem;
	line-height: 1.2em;
	font-weight: ${({ theme }) => theme.font.semiBold};

	${customMinResponsive(
		size.semi,
		css`
			font-size: 2.8rem;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
		`
	)}
`;

export const StyledCloseIcon = styled(CloseIcon)`
	height: 100%;
	path {
		${transitionMain}
		fill: ${({ theme }) => theme.configurator.color.primary};
	}
`;

export const CloseButton = styled(Link)`
	border: none;
	outline: none;
	background: transparent;
	height: 1.8rem;
	width: 4rem;
	cursor: pointer;

	&:hover:not(:disabled) {
		${StyledCloseIcon} {
			path {
				fill: ${({ theme }) => theme.configurator.color.highlight};
			}
		}
	}

	${customMinResponsive(
		size.semi,
		css`
			height: 2.4rem;
		`
	)}
`;
